import { Injectable } from '@angular/core';
import { EDocumentStatus } from '@precheckin/models/enums/document-status.enum';
import { VisitStatus } from '@precheckin/models/enums/visit-status.enum';
import { EVisitDocumentManagementStatus } from '@precheckin/models/visit/visit-document-management-status.enum';
import { VisitDocumentMetaData } from '@precheckin/models/visit-document/visit-document-metadata.model';
import { VisitDocument } from '@precheckin/models/visit-document/visit-document.model';
import { PrechekinFormEnum } from '@precheckin/pages/precheckin-form/precheckin-form.enum';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  areObjectsEqual(obj1: any, obj2: any): boolean {
    // Check if both objects are null or undefined
    if (obj1 === null || obj1 === undefined) {
      return obj2 === null || obj2 === undefined;
    }

    if (obj2 === null || obj2 === undefined) {
      return false;
    }

    // Check if both objects have the same number of properties
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Compare each property's value
    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      // Recursively compare nested objects
      if (typeof val1 === 'object' && typeof val2 === 'object') {
        if (!this.areObjectsEqual(val1, val2)) {
          console.log(val1, val2);
          return false;
        }
      } else if (val1 !== val2) {
        // Compare non-object properties
        console.log(val1, val2);
        return false;
      }
    }

    return true;
  }

  convertMetaDataToObject(metaData: Map<string, VisitDocumentMetaData>): {
    [key: string]: VisitDocumentMetaData;
  } {
    return Object.fromEntries([...metaData].map((x) => [x[0], x[1]]));
  }

  isEditableStep(step: PrechekinFormEnum, checkinStatus: VisitStatus, visitDocumentApprovalStatus: EVisitDocumentManagementStatus, documents: VisitDocument[]): boolean {
    if(checkinStatus != VisitStatus.PRECHECKED_IN) {
      return true;
    }

    if(visitDocumentApprovalStatus  === EVisitDocumentManagementStatus.APPROVED) {
      return false;
    }

    switch (step) {
      case PrechekinFormEnum.PersonalInformation:
      case PrechekinFormEnum.CitizenshipResidency:
        return false;
      case PrechekinFormEnum.Passport:
        if(documents[0].status === EDocumentStatus.APPROVED) {
          return false;
        } else {
          return true;
        }
      case PrechekinFormEnum.PilotLicense:
        if (documents.length > 0 && documents.every(x => x.status === EDocumentStatus.APPROVED)) {
          return false;
        } else {
          return true;
        }
      case PrechekinFormEnum.MedicalCertificate:
        if (documents.length > 0 && documents.every(x => x.status === EDocumentStatus.APPROVED)) {
          return false;
        } else {
          return true;
        }
      case PrechekinFormEnum.Visa:
        if(documents[0].status === EDocumentStatus.APPROVED) {
          return false;
        } else {
          return true;
        }
      case PrechekinFormEnum.HotelInformation:
        return true;
      default:
        return false;
    }
  }
}
